var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('h3',{staticClass:"title"},[_vm._v("Time")]),_c('div',{staticClass:"profile-requested"},[_c('MultiSelect',{staticClass:"w-100",attrs:{"placeholder":"Perfil desejado do time","options":_vm.options},model:{value:(_vm.eventProfileTypes),callback:function ($$v) {_vm.eventProfileTypes=$$v},expression:"eventProfileTypes"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }